import { Component } from '@angular/core';

@Component({
    selector: 'app-mentions-legales',
    templateUrl: './mentions-legales.component.html',
    styleUrl: './mentions-legales.component.css'
})
export class MentionsLegalesComponent {

}
